import { createUseStyles } from "react-jss";
import { darken } from "../../../theme/Mixins";

export default createUseStyles({
    button: {
        background: ({ active, hover }) => darken(active ? "#00A9E8" : "#F3F3F3", hover ? 0.7 : 0),
        color: ({ active }) => (active ? "#fff" : "#484848"),
        margin: [[0, 4]],
        borderRadius: 5,
        padding: ({ layout }) => (layout === "vertical" ? [[8, 12]] : [[4, 16]]),
        minWidth: 64,
        cursor: "pointer",
        fontSize: "12px",
        transition: "background 200ms, color 200ms",
        display: "flex",
        flexDirection: ({ layout }) => (layout === "vertical" ? "column" : "row"),
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        boxSizing: "border-box",
    },
    buttonIcon: {
        fontSize: "18px",
    },
});
